import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Linkify from "react-linkify";
import Icon, { IconTypeNames } from "Components/Icon";
import { Routes } from "Utils/Constants";
import useTransactionInitiated from "Utils/Hooks/useTransactionInitiated";
import useMode, { MODE } from "Utils/Hooks/useMode";
import LoadVipAccount from "Components/LoadVipAccount";
import useSession from "Utils/Hooks/useSession";
import useView, { VIEW } from "Utils/Hooks/useView";
import {
  capitalizeFirstLetter,
  clickifyPhoneNumber,
  getPhoneNumber,
} from "Utils/Utils";

import "./Response.scss";
import MitekInprogress from "Components/MitekInprogress";
import { PRODUCTTYPES } from "Utils/Constants";
import DeviceVerification from "Pages/DeviceVerification/DeviceVerification";
import { Box } from "@mui/material";
import { Button, Stack, Typography } from "@pav/pav-products-design-system";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import RedirectMessageModal from "./RedirectMessageModal";
import { useVipAccountCache } from "context/VipAccountContext";

const Response = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { setVipAccount } = useVipAccountCache();
  const timerRef = useRef(null);
  const redirectTimerRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const { session, invalidateSession } = useSession();
  const { transactionInitiated } = useTransactionInitiated();
  const mode = useMode();
  const view = useView();
  const [deviceverified, setDeviceVerified] = useState(null);
  const [noMobileOnFile, setNoMobileError] = useState(null);
  const productType =
    session?.patronProductType === PRODUCTTYPES.PREFERRED ? "VIPP" : "VIPO";
  document.title =
    productType +
    " - " +
    capitalizeFirstLetter(location.pathname.replace("/", "").replace("\\", ""));

  const isCashier = view === VIEW.cashier;
  var cashierCss = "";
  if (isCashier && session?.uiStyleFields) {
    Object.values(session.uiStyleFields).forEach((style) => {
      cashierCss += style;
    });
  }

  useEffect(() => {
    if (isEnrollment && isSuccess) {
      timerRef.current = setTimeout(() => history.push(navigateTo), 6000);
    }
    if (
      redirectUrl &&
      !session?.toggles?.showTransactionConfirmation &&
      !isCashier
    ) {
      if (
        redirectUrl.transactionSucceeded !== "undefined" &&
        redirectUrl.transactionSucceeded
      ) {
        redirectTimerRef.current = setTimeout(
          () => WcRedirectWithOutCTA(),
          5000,
        );
      }
    }

    window.addEventListener("popstate", (e) => {
      if (location.pathname === "/logout") {
        history.go(1);
      }
    });
    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(redirectTimerRef.current);
      window.removeEventListener("popstate", (e) => {
        if (location.pathname === "/logout") {
          history.go(1);
        }
      });
    };
  }, []);

  const {
    loggedOut = false,
    isEnrollment = false,
    isSuccess = false,
    isError = true,
    isBack = false,
    showButton = true,
    title = "Error",
    message = "An unexpected error has been received and your request cannot be processed. Please contact CAMS at 1-800-500-1973 for support using code I99.",
    fromOperator = {},
    formData = {},
    iconProps = {},
    allowRetry = true,
    showLoginLink = false,
    showHeader = true,
    buttonText,
    onClickClose,
    navigateTo = mode === MODE.manageBanks
      ? Routes.MY_ACCOUNTS
      : transactionInitiated || deviceverified
        ? mode === MODE.withdraw
          ? Routes.WITHDRAW
          : Routes.DEPOSIT
        : Routes.DASHBOARD,
    customButtons,
    redirectUrl,
  } = { ...props, ...location.state };

  const formattedMessage = clickifyPhoneNumber(message);
  const phoneNumber = getPhoneNumber(message);

  const defaultIconTypeName =
    location.pathname === "/deviceverificationerror"
      ? IconTypeNames.deviceVerificationError
      : isEnrollment
        ? isSuccess
          ? IconTypeNames.enrollsuccess
          : IconTypeNames.enrollfail
        : location.pathname === "/success" || location.pathname === "/logout"
          ? IconTypeNames.check
          : !loggedOut || !isBack
            ? IconTypeNames.error
            : IconTypeNames.check;
  iconProps.typeName = iconProps.typeName ?? defaultIconTypeName;

  const customButtonsComponents = customButtons?.map((customButton, index) => {
    return (
      <Box sx={{ width: "100%", margin: "var(--spacing-xxs) 0" }}>
        {isCashier ? null : redirectUrl &&
          !session?.showTransactionConfirmation ? (
          <RedirectMessageModal
            label={customButton.label}
            operatorName={session.operatorName}
          />
        ) : (
          <Button
            fullWidth
            buttonType={
              location.pathname === "/success" ||
              customButton.style === "secondary"
                ? "secondary"
                : customButton.style === "primary"
                  ? "primary"
                  : customButton.zeroBal ||
                      customButton.label === "CANCEL" ||
                      customButton.label === "Add New Funding Source" ||
                      customButton.label === "Complete Deposit"
                    ? "secondary"
                    : "primary"
            }
            className={
              customButton.zeroBal || customButton.label === "CANCEL"
                ? "click-cancel"
                : "submit-button click-return-to-opr"
            }
            onClick={() => {
              customButton.returnToOperator
                ? WcRedirect(customButton)
                : history.push({
                    pathname: customButton.route,
                    state: { notRedirect: customButton.notRedirect },
                  });
            }}
          >
            {customButton.label}
          </Button>
        )}
      </Box>
    );
  });

  function WcRedirect(customButton) {
    if (customButton.returnUrl) {
      var queryStringSeperator = customButton.returnUrl.includes("?")
        ? "&"
        : "?";
      window.location.replace(
        customButton.returnUrl +
          queryStringSeperator +
          "transactionId=" +
          customButton.transactionId +
          "&transactionType=" +
          customButton.transactionType,
      );
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      } else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        }
      }
    }
    invalidateSession();
    setVipAccount(null);
  }

  function WcRedirectWithOutCTA() {
    if (redirectUrl && redirectUrl.returnUrl) {
      var queryStringSeperator = redirectUrl.returnUrl.includes("?")
        ? "&"
        : "?";
      window.location.replace(
        redirectUrl.returnUrl +
          queryStringSeperator +
          "transactionId=" +
          redirectUrl.transactionId +
          "&transactionType=" +
          redirectUrl.transactionType,
      );
    } else {
      if (window.opener !== null && !window.opener.closed) {
        window.close();
      } else if (
        window.parent !== null &&
        window.parent.frames !== null &&
        window.parent.frames.length > 0
      ) {
        window.parent.postMessage("close", "*");
      } else {
        if (/android/i.test(navigator.userAgent)) {
          if (typeof window !== undefined) {
            window.postMessage("close", "*");
          } else if (document !== undefined) {
            document.postMessage("close", "*");
          }
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
          window.postMessage("close", "*");
        }
      }
    }
    invalidateSession();
    setVipAccount(null);
  }

  const onClick = () => {
    if (isError) {
      window.postMessage("close", "*");
    }
    if (onClickClose && window.opener !== null && !window.opener.closed) {
      window.close();
      return;
    }

    isError && allowRetry
      ? history.push({
          pathname: "/retry",
          state: {
            isError: true,
            fromOperator,
            formData,
            message,
          },
        })
      : history.push(navigateTo);
  };

  useEffect(() => {
    if (deviceverified === false) {
      redirectTimerRef.current = setTimeout(
        () => WcRedirect(customButtons[0]),
        20000,
      );
    } else if (deviceverified) {
      history.push(navigateTo);
    } else if (noMobileOnFile) {
      history.push({ pathname: "/deviceverificationerror" });
    }
  }, [deviceverified, noMobileOnFile]);

  if (location.pathname === "/inprogress") {
    return (
      <>
        <MitekInprogress></MitekInprogress>
      </>
    );
  } else if (!isEnrollment && location.pathname === "/deviceverification") {
    return (
      <DeviceVerification
        verified={setDeviceVerified}
        noMobileError={setNoMobileError}
      />
    );
  } else if (
    location.pathname === "/zerobalance" ||
    location.pathname === "/expired" ||
    isError ||
    loggedOut ||
    isBack
  ) {
    return (
      <Stack className="expired">
        <Icon {...iconProps} />
        <Stack
          className={`response ${!isMobile && "mobile"}`}
          gap={"var(--spacing-md)"}
          mb="32px"
          mt="12px"
        >
          <Box
            className={
              location.pathname === "/deviceverificationerror"
                ? "header"
                : `response-header ${!loggedOut && !isBack && "error"}`
            }
          >
            {title}
          </Box>
          <div className="response-message">
            {location.pathname === "/zerobalance" ? (
              <>
                <Typography weight="bold">Account Balance</Typography>
                <Typography>{formattedMessage}</Typography>
              </>
            ) : (
              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <a target="blank" href={decoratedHref} key={key}>
                    {decoratedText}
                  </a>
                )}
              >
                {message ===
                "We are unable to complete this request. Please contact our Customer Service Team at 1-800-500-1973. Reference code E-92 so that we may better serve you." ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    <Typography sx={{ fontWeight: 700 }}>
                      We are unable to complete this request.
                    </Typography>
                    <Typography sx={{ fontWeight: 400 }}>
                      Please contact our Customer Service Team at{" "}
                      <span
                        style={{
                          color: "#237537",
                          fontWeight: 700,
                          textDecoration: "underline",
                        }}
                      >
                        1-800-500-1973
                      </span>
                      , then inform the{" "}
                      <span style={{ fontWeight: 700 }}>
                        CODE{" "}
                        <span style={{ textDecoration: "underline" }}>
                          E-92
                        </span>
                      </span>{" "}
                      so that we may better serve you.
                    </Typography>
                    <Box></Box>
                    <Box
                      sx={{
                        gap: "10px",
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "32px",
                      }}
                    >
                      <Button
                        buttonType="secondary"
                        fullWidth
                        padding="var(--spacing-lg, 16px)"
                        href={`tel:1-800-500-1973`}
                        component={"a"}
                        className="call-button"
                      >
                        Call Now
                      </Button>
                      <Button
                        fullWidth
                        padding="var(--spacing-lg, 16px)"
                        onClick={() => history.push("/dashboard")}
                      >
                        Ok
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <>
                    <Typography weight="bold">
                      {props.messageTop ? props.messageTop : formattedMessage}
                    </Typography>
                    {props.messageBottom && (
                      <Typography
                        weight="bold"
                        sx={{ marginTop: "var(--spacing-xl)" }}
                      >
                        {clickifyPhoneNumber(props.messageBottom)}
                      </Typography>
                    )}
                  </>
                )}
                {(location.pathname === "/logout" ||
                  location.pathname === "/expired") && (
                  <Box sx={{ marginTop: "32px" }}>
                    {customButtonsComponents}
                  </Box>
                )}
              </Linkify>
            )}
          </div>
        </Stack>
        {!location.pathname === "/deviceverificationerror" && (
          <Stack className="response-buttons">
            {phoneNumber && (
              <Button
                buttonType="secondary"
                fullWidth
                sx={{ mb: "1rem" }}
                href={`tel:+${phoneNumber}`}
              >
                Call Now
              </Button>
            )}
            {!isSuccess && showButton && !customButtons && !isBack && (
              <Button
                onClick={onClick}
                buttonType="primary"
                fullWidth
                className="submit-button click-expired-or-error-ok"
              >
                {buttonText || (isError ? "Ok" : "Done")}
              </Button>
            )}
            {customButtonsComponents}
            {showLoginLink && <a href="/">Log In</a>}
          </Stack>
        )}
      </Stack>
    );
  } else {
    return (
      <LoadVipAccount isEnrollment={isEnrollment}>
        <style>{cashierCss}</style>
        <div className="cashier-background">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "var(--spacing-md)",
            }}
            className="response"
          >
            <Box
              className="header"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon {...iconProps} />
            </Box>
            <Box
              className="header"
              sx={{ textAlign: { xs: "left", md: "center" } }}
            >
              {title}
            </Box>
            <Box
              className="response-message"
              sx={{ textAlign: { xs: "left", md: "center" } }}
            >
              {title === "Withdrawal In Progress" ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--spacing-md)",
                  }}
                >
                  <Box>The funds will be available shortly.</Box>
                  <Box sx={{ fontWeight: 400 }}>
                    Your <b>${location.state.amount}</b> withdrawal from your{" "}
                    <b>{location.state.oprName}</b> account to your{" "}
                    <b>{location.state.bankName}</b> account is currently in
                    progress.
                  </Box>
                </Box>
              ) : (
                <Linkify
                  componentDecorator={(decoratedHref, decoratedText, key) => (
                    <a target="blank" href={decoratedHref} key={key}>
                      {decoratedText}
                    </a>
                  )}
                >
                  {formattedMessage}
                </Linkify>
              )}
            </Box>
            {!isSuccess && showButton && !customButtons && (
              <Button fullWidth onClick={onClick}>
                {buttonText || (isError ? "Ok" : "Done")}
              </Button>
            )}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "32px",
              }}
            >
              {customButtonsComponents}
            </Box>
            {showLoginLink && <a href="/">Log In</a>}
          </Box>
        </div>
      </LoadVipAccount>
    );
  }
};

export default Response;
